const baseStyle = ({ progress }: Record<string, any>) => ({
  _progress: {
    width: `${progress}%`,
    overflow: 'hidden',
    position: 'absolute',
    left: 0,
    top: 0,
    borderRadius: 'sm',
    bg: {
      linearGradient: {
        colors: ['green.500', 'green.700'],
        start: [0, 0],
        end: [1, 0],
      },
    },
    style: {
      boxShadow: 'inset 0px 1px 0px 0px #00000040',
    },
  },
  _container: {
    shadow: 0,
    borderRadius: 'sm',
    bgColor: 'white',
    width: '100%',
  },
  _content: {
    px: 2,
    py: 1,
    justifyContent: 'space-between',
    alignContent: 'center',
    borderRadius: 'sm',
    style: {
      boxShadow: 'inset 0px 1px 0px 0px #00000026',
    },
  },
  _text: {
    fontSize: 'md',
    lineHeight: 'md',
    color: 'darkText',
  },
  _textFilled: {
    color: 'white',
  },
  _icon: {
    size: 5,
    ml: 2,
    color: 'gray.900',
  },
  _iconFilled: {
    color: 'white',
  },
});

export default {
  baseStyle,
};
